import {
    GET_OD_REQUEST,
    GET_OD_SUCCESS,
    GET_OD_FAILURE,
} from "./constants";

export interface IState {
    startDate: Date;
    stopDate: Date;
    gotData: boolean;
    loading: boolean;
    error: null | string;
    scoreData: any;
    graphData: any;
}

export const initialState: any = {
    gotData: false,
    loading: false,
    error: null,
    startDate: new Date(),
    stopDate: new Date(),
    scoreData: [],
    graphData: [],
};

export const ODReducer = (state: any = initialState, action: any) => {
    switch (action.type) {
        case GET_OD_REQUEST:
            return {
                ...state,
                gotData: false,
                loading: true,
                error: null,
            };
        case GET_OD_SUCCESS:

            const newState = {
                ...state,
                loading: false,
                gotData: true,
                scoreData: action.payload.scoreData,
                graphData: action.payload.graphData,
            };

            return newState;

        case GET_OD_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.payload,
            };
        default:
            return state;
    }
};
